import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M426.667 85.333q0 85.334-85.334 85.334-85.333 0-85.333-85.334Q256 0 341.333 0q85.334 0 85.334 85.333ZM426.667 512q0 85.333-85.334 85.333Q256 597.333 256 512t85.333-85.333q85.334 0 85.334 85.333ZM426.667 938.6669999999999q0 85.333-85.334 85.333Q256 1024 256 938.667q0-85.334 85.333-85.334 85.334 0 85.334 85.334ZM768 85.333q0 85.334-85.333 85.334-85.334 0-85.334-85.334Q597.333 0 682.667 0 768 0 768 85.333ZM768 512q0 85.333-85.333 85.333-85.334 0-85.334-85.333t85.334-85.333Q768 426.667 768 512ZM768 938.6669999999999Q768 1024 682.667 1024q-85.334 0-85.334-85.333 0-85.334 85.334-85.334 85.333 0 85.333 85.334Z" fill="#91919F" /></svg>

const Drag = React.forwardRef((props, ref) => {
  return (
    <IconBase name="drag" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Drag.displayName = 'IconDrag'

export default Drag
